import Vue from 'vue'
import $https from '@/plugins/axios'
import $socket from '@/plugins/socket'

const pageSize = 20

const initData = (projectId) => {
  return {
    projectId,
    isPanelShow: false,
    todoList: [],
    messageList: [],
    todoCount: 0,
    messageCount: 0,
    messageUnreadCount: 0
  }
}

const state = {
  notification: initData(),
  tab: ''
}

const getters = {
  notification: state => {
    return state.notification
  }
}

const mutations = {
  SET_NOTIFICATION_DATA (state, notificationData) {
    for (const property in notificationData) {
      Vue.set(state.notification, property, notificationData[property])
    }
  },
  INSERT_TODO_LIST (state, todoList) {
    for (const todo of todoList) {
      if (!state.notification.todoList.find(item => item.id === todo.id)) {
        state.notification.todoList.splice(0, 0, todo)
        ++state.notification.todoCount
      }
    }
  },
  APPEND_TODO_LIST (state, todoList) {
    for (const todo of todoList) {
      if (!state.notification.todoList.find(item => item.id === todo.id)) {
        state.notification.todoList.push(todo)
      }
    }
  },
  ADD_MESSAGE_LIST (state, messageList) {
    for (const message of messageList) {
      // TODO 前端自定义类型，后期消息改版，需要和后端对接
      if (message.message.indexOf('【') !== -1) {
        message.type = 1
      } else {
        message.type = 2
      }
      if (!state.notification.messageList.find(item => item.id === message.id)) {
        state.notification.messageList.push(message)
      }
    }
  },
  REMOVE_TODO (state, todoId) {
    const index = state.notification.todoList.findIndex(item => item.id === todoId)
    if (index !== -1) {
      state.notification.todoList.splice(index, 1)
      state.notification.todoCount = state.notification.todoCount <= 0 ? 0 : state.notification.todoCount - 1
    }
  },
  READ_MESSAGE (state, messageId) {
    const message = state.notification.messageList.find(item => item.id === messageId)
    if (message && !message.isRead) {
      message.isRead = 1
      state.notification.messageUnreadCount = state.notification.messageUnreadCount <= 0 ? 0 : state.notification.messageUnreadCount - 1
    }
  },
  SET_TAB (state, tab) {
    state.tab = tab
  }
}

const actions = {
  async InitNotificationData ({ state, dispatch, commit }, projectId) {
    let notificationData = initData(projectId)
    commit('SET_NOTIFICATION_DATA', notificationData)
    const promiseList = [
      dispatch('GetMoreTodoList'),
      dispatch('GetMoreMessageList'),
      $https.axios({ method: 'get', url: 'messageRemind/count', params: { projectId, pageSize } })
    ]
    const responseList = await Promise.all(promiseList)
    notificationData = {
      todoList: state.notification.todoList,
      messageList: state.notification.messageList,
      todoCount: responseList[2].data.alarmCount,
      messageUnreadCount: responseList[2].data.noticeCount
    }
    commit('SET_NOTIFICATION_DATA', notificationData)
  },
  async GetMoreTodoList ({ state, commit }) {
    const params = { projectId: state.notification.projectId, pageSize }
    const todoListLength = state.notification.todoList.length
    if (todoListLength) {
      params.alarmTime = state.notification.todoList[todoListLength - 1].alarmTime
    }
    const response = await $https.axios({ method: 'get', url: 'userTodoLog/list', params })
    if (!response.data.data.length) {
      state.notification.todoCount = state.notification.todoList.length
    } else {
      commit('APPEND_TODO_LIST', response.data.data)
      state.notification.todoCount = state.notification.todoList.length > response.data.total ? state.notification.todoList.length : response.data.total
    }
    return response.data.data
  },
  async GetMoreMessageList ({ state, commit }) {
    const params = { projectId: state.notification.projectId, pageSize }
    const messageListLength = state.notification.messageList.length
    if (messageListLength) {
      params.createTime = state.notification.messageList[messageListLength - 1].createTime
    }
    const response = await $https.axios({ method: 'get', url: 'messageRemind/messageList', params })
    if (!response.data.data.length) {
      state.notification.messageCount = state.notification.messageList.length
    } else {
      commit('ADD_MESSAGE_LIST', response.data.data)
      state.notification.messageCount = state.notification.messageList.length > response.data.total ? state.notification.messageList.length : response.data.total
    }
    return response.data
  },
  async CheckMessageList ({ state }) {
    const params = { projectId: state.notification.projectId, pageSize }
    const response = await $https.axios({ method: 'get', url: 'messageRemind/messageList', params })
    if (response.data.data.length) {
      for (let i = response.data.data.length - 1; i >= 0; --i) {
        const message = response.data.data[i]
        if (!state.notification.messageList.find(item => item.id === message.id) && !message.isRead) {
          state.notification.messageList.splice(0, 0, message)
          ++state.notification.messageCount
          ++state.notification.messageUnreadCount
        }
      }
    }
  },
  async CloseTodoAlarm ({ commit }, data) {
    const response = await $https.axios({ method: 'get', url: '/userTodoLog/close', params: data })
    commit('REMOVE_TODO', data.id)
    return response.data
  },
  async ReadMessages ({ getters, commit }, messageIds) {
    const data = { projectId: state.notification.projectId, ids: messageIds }
    const response = await $https.axios({ method: 'post', url: '/messageRemind/readMessage', data })
    for (const id of messageIds) {
      commit('READ_MESSAGE', id)
    }
    return response.data
  }
}

$socket.addListener('10010102', data => {
  mutations.REMOVE_TODO(state, data.data.id)
})

$socket.addListener('10010101', data => {
  mutations.INSERT_TODO_LIST(state, [data.data])
})

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/notification.js